import { render, staticRenderFns } from "./CombinedSalaryDataForUser.vue?vue&type=template&id=3046c053&scoped=true"
import script from "./CombinedSalaryDataForUser.vue?vue&type=script&lang=js"
export * from "./CombinedSalaryDataForUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3046c053",
  null
  
)

export default component.exports